import React from "react";
import { DARWIN_NAVY, DARWIN_NAVY_3 } from "../../../constants";

export const StarIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 -1 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0748 4.47265C18.0109 4.27318 17.8891 4.09719 17.725 3.96701C17.5609 3.83682 17.3619 3.75829 17.1531 3.74139L14.1621 3.48826L12.9953 0.768112C12.913 0.577415 12.7766 0.414995 12.603 0.300888C12.4295 0.186781 12.2263 0.125977 12.0186 0.125977C11.8108 0.125977 11.6077 0.186781 11.4341 0.300888C11.2605 0.414995 11.1242 0.577415 11.0418 0.768112L9.87499 3.48906L6.88323 3.74139C6.67549 3.75808 6.47734 3.83591 6.31378 3.96508C6.15023 4.09424 6.02858 4.26895 5.9642 4.46717C5.89982 4.66539 5.89558 4.87823 5.95202 5.07885C6.00846 5.27947 6.12306 5.45889 6.28134 5.59446L8.54425 7.52307L7.86682 10.3943C7.81919 10.5955 7.8319 10.8064 7.90336 11.0004C7.97481 11.1945 8.10185 11.3633 8.26862 11.4856C8.43735 11.6095 8.63886 11.6809 8.84796 11.6909C9.05706 11.7009 9.26448 11.6491 9.44427 11.5418L12.0157 10.015L14.5872 11.5418C14.767 11.6491 14.9744 11.7009 15.1835 11.6909C15.3926 11.6809 15.5942 11.6095 15.7629 11.4856C15.9297 11.3633 16.0568 11.1946 16.1283 11.0005C16.1998 10.8064 16.2124 10.5955 16.1647 10.3943L15.4872 7.52307L17.7494 5.59446C17.9086 5.4607 18.0245 5.28268 18.0824 5.08297C18.1403 4.88327 18.1377 4.67086 18.0748 4.47265ZM14.5503 6.64234C14.4022 6.76779 14.2918 6.93185 14.2314 7.11627C14.1709 7.30069 14.1628 7.49825 14.2079 7.68701L14.7954 10.1781L12.563 8.85141C12.3982 8.75318 12.21 8.70132 12.0182 8.70132C11.8263 8.70132 11.6381 8.75318 11.4733 8.85141L9.24096 10.1701L9.82838 7.67897C9.87414 7.49031 9.86643 7.29262 9.8061 7.10809C9.74578 6.92357 9.63523 6.7595 9.48686 6.63431L7.53735 4.97731L10.1161 4.75873C10.3075 4.74267 10.4909 4.6748 10.6466 4.56239C10.8023 4.44998 10.9245 4.29728 11 4.12068L12.0182 1.7517L13.0339 4.12068C13.1096 4.29718 13.2318 4.44978 13.3875 4.56217C13.5432 4.67456 13.7265 4.7425 13.9178 4.75873L16.4966 4.97731L14.5503 6.64234ZM5.72285 8.93739L1.22275 13.4375C1.10213 13.5581 0.938518 13.6259 0.767923 13.6259C0.597328 13.6259 0.433721 13.5581 0.313092 13.4375C0.192463 13.3169 0.124695 13.1532 0.124695 12.9827C0.124695 12.8121 0.192463 12.6485 0.313092 12.5278L4.81319 8.02773C4.93381 7.9071 5.09742 7.83933 5.26802 7.83933C5.43861 7.83933 5.60222 7.9071 5.72285 8.02773C5.84348 8.14836 5.91125 8.31196 5.91125 8.48256C5.91125 8.65315 5.84348 8.81676 5.72285 8.93739ZM7.00859 13.4375L2.5085 17.9376C2.44877 17.9973 2.37786 18.0447 2.29982 18.077C2.22178 18.1093 2.13813 18.126 2.05366 18.126C1.96919 18.126 1.88555 18.1093 1.80751 18.077C1.72947 18.0447 1.65856 17.9973 1.59883 17.9376C1.5391 17.8778 1.49172 17.8069 1.4594 17.7289C1.42707 17.6509 1.41044 17.5672 1.41044 17.4827C1.41044 17.3983 1.42707 17.3146 1.4594 17.2366C1.49172 17.1586 1.5391 17.0876 1.59883 17.0279L6.09893 12.5278C6.21956 12.4072 6.38316 12.3394 6.55376 12.3394C6.72435 12.3394 6.88796 12.4072 7.00859 12.5278C7.12922 12.6485 7.19699 12.8121 7.19699 12.9827C7.19699 13.1532 7.12922 13.3169 7.00859 13.4375ZM12.7944 12.5278C12.8542 12.5875 12.9016 12.6584 12.934 12.7365C12.9663 12.8145 12.983 12.8982 12.983 12.9827C12.983 13.0671 12.9663 13.1508 12.934 13.2288C12.9016 13.3069 12.8542 13.3778 12.7944 13.4375L8.29433 17.9376C8.2346 17.9973 8.16369 18.0447 8.08565 18.077C8.00761 18.1093 7.92397 18.126 7.8395 18.126C7.75503 18.126 7.67139 18.1093 7.59335 18.077C7.51531 18.0447 7.4444 17.9973 7.38467 17.9376C7.32494 17.8778 7.27756 17.8069 7.24523 17.7289C7.21291 17.6509 7.19627 17.5672 7.19627 17.4827C7.19627 17.3983 7.21291 17.3146 7.24523 17.2366C7.27756 17.1586 7.32494 17.0876 7.38467 17.0279L11.8848 12.5278C11.9445 12.468 12.0154 12.4206 12.0934 12.3883C12.1715 12.3559 12.2551 12.3393 12.3396 12.3393C12.4241 12.3393 12.5077 12.3559 12.5858 12.3883C12.6638 12.4206 12.7347 12.468 12.7944 12.5278Z"
        fill={DARWIN_NAVY_3}
      />
    </svg>
  );
};

export const CompareIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="-1 -1 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.75 2.375H9.125V1.25C9.125 0.951631 9.00647 0.665483 8.79549 0.454505C8.58452 0.243526 8.29837 0.125 8 0.125H1.25C0.951631 0.125 0.665483 0.243526 0.454505 0.454505C0.243526 0.665483 0.125 0.951631 0.125 1.25V12.5C0.125 12.7984 0.243526 13.0845 0.454505 13.2955C0.665483 13.5065 0.951631 13.625 1.25 13.625H6.875V14.75C6.875 15.0484 6.99353 15.3345 7.20451 15.5455C7.41548 15.7565 7.70163 15.875 8 15.875H14.75C15.0484 15.875 15.3345 15.7565 15.5455 15.5455C15.7565 15.3345 15.875 15.0484 15.875 14.75V3.5C15.875 3.20163 15.7565 2.91548 15.5455 2.7045C15.3345 2.49353 15.0484 2.375 14.75 2.375ZM1.25 7.4375H4.72063L3.26938 8.89438L4.0625 9.6875L6.875 6.875L4.0625 4.0625L3.26938 4.85562L4.72063 6.3125H1.25V1.25H8V12.5H1.25V7.4375ZM8 14.75V13.625C8.29837 13.625 8.58452 13.5065 8.79549 13.2955C9.00647 13.0845 9.125 12.7984 9.125 12.5V3.5H14.75V8.5625H11.2794L12.7306 7.10562L11.9375 6.3125L9.125 9.125L11.9375 11.9375L12.7306 11.1444L11.2794 9.6875H14.75V14.75H8Z"
        fill={DARWIN_NAVY_3}
      />
    </svg>
  );
};

export const BackIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.259196 8.82642V8.82591C0.259196 8.69612 0.279605 8.57598 0.319656 8.46472C0.358302 8.35737 0.424034 8.25544 0.519726 8.15907C0.519769 8.15903 0.519812 8.15898 0.519856 8.15894L7.47272 1.20607C7.64662 1.03217 7.86342 0.940703 8.12972 0.932965C8.39155 0.925358 8.61515 1.01503 8.8062 1.20607L8.80614 1.20614L8.80934 1.20908C8.99984 1.3837 9.09841 1.59971 9.10671 1.86332C9.11494 2.12484 9.0251 2.34827 8.83278 2.53932L8.83254 2.53955L3.67039 7.7017L3.49968 7.87241H3.7411H15.514C15.7872 7.87241 16.0118 7.9639 16.1944 8.14653C16.377 8.32915 16.4681 8.55328 16.4675 8.82568V8.82591C16.4675 9.09928 16.3762 9.32387 16.1943 9.50647C16.0125 9.68888 15.7882 9.78006 15.5142 9.77942H15.514H3.7411H3.49968L3.67039 9.95013L8.83254 15.1123C9.00592 15.2857 9.09827 15.5064 9.10671 15.7821C9.11499 16.0529 9.02464 16.2701 8.8358 16.4426L8.83554 16.4423L8.82953 16.4489C8.65626 16.6379 8.43766 16.7325 8.1658 16.7325C7.89378 16.7325 7.66463 16.6377 7.47272 16.4458L0.51962 9.49265C0.423215 9.39625 0.357206 9.29434 0.318602 9.18711C0.278612 9.07602 0.258547 8.95605 0.259196 8.82642Z"
        fill={DARWIN_NAVY}
        stroke="white"
        stroke-width="0.2"
      />
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8457 1.4189C12.0312 1.23346 12.2513 1.08636 12.4936 0.985999C12.7359 0.885639 12.9956 0.833984 13.2579 0.833984C13.5201 0.833984 13.7798 0.885639 14.0221 0.985999C14.2644 1.08636 14.4845 1.23346 14.67 1.4189C14.8554 1.60434 15.0025 1.82449 15.1029 2.06678C15.2032 2.30908 15.2549 2.56876 15.2549 2.83102C15.2549 3.09327 15.2032 3.35295 15.1029 3.59525C15.0025 3.83754 14.8554 4.05769 14.67 4.24313L5.1382 13.7749L1.25488 14.834L2.31397 10.9507L11.8457 1.4189Z"
        stroke={DARWIN_NAVY}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ChevronDoubleUpIcon = ({ fill }) => {
  return (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5575 10.8075L0.5 9.75L5 5.25L9.5 9.75L8.4425 10.8075L5 7.3725L1.5575 10.8075ZM1.5575 6.3075L0.5 5.25L5 0.75L9.5 5.25L8.4425 6.3075L5 2.8725L1.5575 6.3075Z"
        fill={fill}
      />
    </svg>
  );
};

export const ChevronUpIcon = ({ fill }) => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5575 5.5575L5 2.1225L8.4425 5.5575L9.5 4.5L5 0L0.5 4.5L1.5575 5.5575Z"
        fill={fill}
      />
    </svg>
  );
};

export const ApproxEqualIcon = ({ fill }) => {
  return (
    <svg
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.175 1.90039C10.575 2.57539 9.45 3.25039 8.25 3.25039C7.125 3.25039 6.45 2.87539 5.85 2.57539C5.25 2.35039 4.65 1.97539 3.675 1.97539C2.775 1.97539 1.95 2.50039 1.5 2.95039L0.75 1.82539C1.425 1.15039 2.475 0.400391 3.675 0.400391C4.8 0.400391 5.475 0.850391 6.075 1.07539C6.675 1.30039 7.275 1.75039 8.25 1.75039C9.15 1.75039 9.975 1.15039 10.425 0.700391L11.175 1.90039ZM11.25 5.57539C10.575 6.25039 9.525 7.00039 8.325 7.00039C7.2 7.00039 6.525 6.62539 5.925 6.32539C5.325 6.10039 4.725 5.65039 3.75 5.65039C2.85 5.65039 2.025 6.25039 1.575 6.70039L0.825 5.50039C1.5 4.82539 2.55 4.07539 3.75 4.07539C4.875 4.07539 5.55 4.45039 6.15 4.75039C6.75 4.97539 7.35 5.35039 8.325 5.35039C9.225 5.35039 10.05 4.75039 10.5 4.30039L11.25 5.57539Z"
        fill={fill}
      />
    </svg>
  );
};

export const ChevronDownIcon = ({ fill }) => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5575 0.43457L5 3.87707L8.4425 0.43457L9.5 1.49957L5 5.99957L0.5 1.49957L1.5575 0.43457Z"
        fill={fill}
      />
    </svg>
  );
};

export const ChevronDoubleDownIcon = ({ fill }) => {
  return (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.4425 0.192383L9.5 1.24988L5 5.74988L0.5 1.24988L1.5575 0.192383L5 3.62738L8.4425 0.192383ZM8.4425 4.69238L9.5 5.74988L5 10.2499L0.5 5.74988L1.5575 4.69238L5 8.12738L8.4425 4.69238Z"
        fill={fill}
      />
    </svg>
  );
};
